module.exports = __webpack_public_path__ + "static/the-peak-rera_page-0001-80ac97efb0161d9c23198e5451102a81.jpg";